<template>
  <div class="message">
    <form>
      <h1>{{ $t("authorization.message") }}</h1>
      <h2>{{ $t("authorization.validation") }}</h2>
      <router-link
        class="clear"
        :to="
          $authI18nRoute({
            name: 'LogIn',
          })
        "
        >{{ $t("authorization.clear") }}</router-link
      >
    </form>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.message {
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    h1 {
      font-size: 1.5em;
      line-height: 1.4em;
      font-weight: 400;
      color: var(--title-color);
      padding-left: 5.5rem;
      padding-right: 5.5rem;
      padding-top: 2.5rem;
    }
    h2 {
      font-size: 1.3em;
      line-height: 1.2em;
      font-weight: 400;
      color: var(--explanation-color);
      margin-top: 1.8rem;
      margin-bottom: 3rem;
    }
    .clear {
      font-size: 1.5em;
      line-height: 1.4em;
      font-weight: 400;
      width: 18rem;
      height: 3.7rem;
      color: var(--light);
      background: var(--final-btn);
      margin-bottom: 2.1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
@media screen and (max-width: 1366px) {
  .message {
    form {
      h1 {
        padding-left: 3rem;
        padding-right: 3rem;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .message {
    form {
      h1 {
        padding-left: 0rem;
        padding-right: 0rem;
        text-align: center;
      }
    }
  }
}
</style>